/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';

export interface ApiWatchlistIdDelete$JsonOdataMetadataFull$Params {
  id: number;
}

export function apiWatchlistIdDelete$JsonOdataMetadataFull(http: HttpClient, rootUrl: string, params: ApiWatchlistIdDelete$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistIdDelete$JsonOdataMetadataFull.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiWatchlistIdDelete$JsonOdataMetadataFull.PATH = '/api/watchlist/{id}';
